import HeroBanner from "../../../components/sections/front/home/HeroBanner";
import Contact from "../../../components/sections/front/home/Contact";
import Features from "../../../components/sections/front/home/Features";
import JourneySteps from "../../../components/sections/front/home/JourneySteps";
import Security from "../../../components/sections/front/home/Security";
import Preview from "../../../components/sections/front/home/Preview";
import Faq from "../../../components/sections/front/home/Faq";
export default function index() {
 
  return (
    <>
      <HeroBanner/>
      <Features/>
      <JourneySteps/>
      <Security/>
      <Preview/>
      <Faq/>
      <Contact/>
    </>
  );
}